<template>
    <div class="company-main">
        <form @submit.prevent="editRole">
            <div class="tab-content-inner">
                <template v-if="permissions != null">
                    <div class="people-management-inner-content p-5">
                        <div class="form-group">
                            <label>Name</label>
                            <input v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }" />
                            <has-error :form="form" field="username"></has-error>
                        </div>
                        <div class="user-permissions">
                            <div class="form-group" v-for="(permission, index) in permissions" v-bind:key="permission.id">
                                <label class="label block-label"> <span class="highlight-color">{{index}}</span> </label>
                                <div class="permissions-box">
                                    <div class="row">
                                        <div class="col-md-4 mb-2" v-for="child in permission">
                                            <label class="check-holder ml-0">
                                                <span class="check-text"> {{child.display_name}} </span> <i class="fas fa-info-circle" data-toggle="tooltip" data-placement="top" :title="child.description"></i>
                                                <input type="checkbox" v-bind:value="child.id" v-bind:id="'permission_'+child.id" v-model="form.rolePermissions" />
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <div class="form-group">
                    <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                    <router-link to="/listRolesAdmin" class="btn btn-primary float-right mr-1"> Cancel </router-link>
            </div>
            </div>
            
            
        </form>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form : new Form({
                    id: '',
                    name: '',
                    rolePermissions : [],
                }),
                permissions : null,
            };
        },
        updated(){
        },
        methods: {
            editRole() {
                this.$Progress.start();
                this.form.put('/api/updateAdminRole')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        toast.fire({
                            type: 'success',
                            title: 'Role updated successfully'
                        });
                        this.$router.push('/listRolesAdmin');
                    }else{
                        this.$Progress.fail();
                        swal.fire({
                            type: 'error',
                            title: 'Some problem in your form data'
                        });
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    swal.fire({
                        type: 'error',
                        title: 'Some problem in your form data'
                    });
                });
            }
        },
        mounted() {
            this.$Progress.start();
            axios.get('/api/manageEditRole/'+this.$route.params.id)
            .then(res => {
                if(res.status == 200){
                    this.form.name = res.data.role.name;
                    this.form.id = res.data.role.id;
                    this.permissions = res.data.permissions;
                    $.each(res.data.rolePermissions, (key, value) => {
                        this.form.rolePermissions.push(value.id);
                    });
                    this.$Progress.finish();
                }else{
                    this.$Progress.fail();
                    swal.fire({
                        type: 'error',
                        title: 'Error to load form data'
                    });
                }
            })
            .catch(err => {
                this.$Progress.fail();
                swal.fire({
                    type: 'error',
                    title: 'Error to load form data'
                });
            });
        }
    }
</script>
